
const LAST_SHOWN_KEY = 'pwa-install-last-shown'
const COOLDOWN = 7 * 24 * 60 * 60 * 1000
// const COOLDOWN = 30 * 60 * 1000 // for testing

export default {
  data() {
    return {
      install_prompt: null,
    }
  },
  computed: {
    app_name() {
      return this.$global.max_style ? 'Max' : 'Genrate.ai'
    },
    ios() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    },
    android() {
      return /Android/i.test(navigator.userAgent)
    },
    installed() {
      return window.matchMedia('(display-mode: standalone)').matches
        || window.navigator.standalone === true
    },
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', this.saveInstallPrompt)
    window.addEventListener('appinstalled', this.onInstalled)
    if (this.ios) this.open()
  },
  beforeUnmount() {
    window.removeEventListener('beforeinstallprompt', this.saveInstallPrompt)
    window.removeEventListener('appinstalled', this.onInstalled)
  },
  methods: {
    open() {
      const last_shown = Number(localStorage.getItem(LAST_SHOWN_KEY))
      const shown_recently = Number.isFinite(last_shown)
        && last_shown > 0
        && (Date.now() - last_shown) < COOLDOWN

      if (shown_recently || this.installed) return

      localStorage.setItem(LAST_SHOWN_KEY, Date.now().toString())
      this.$refs.modal.open()
    },
    saveInstallPrompt(event) {
      event.preventDefault()
      this.install_prompt = event
      if (this.android) this.open()
    },
    onInstalled() {
      this.install_prompt = null
      this.$refs.modal.close()
    },
    dismiss() {
      this.$refs.modal.close()
    },
    async install() {
      await this.install_prompt.prompt()
      await this.install_prompt.userChoice
      this.install_prompt = null
      this.$refs.modal.close()
    },
  },
}
